var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64941 9.97852H9.34424L9.51562 3.83398H7.48438L7.64941 9.97852ZM8.5 13.1841C9.21729 13.1841 9.65527 12.7778 9.65527 12.124C9.65527 11.4639 9.21729 11.0576 8.5 11.0576C7.78906 11.0576 7.34473 11.4639 7.34473 12.124C7.34473 12.7778 7.78906 13.1841 8.5 13.1841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleProblem);
export default __webpack_public_path__ + "static/media/google_problem.56169a295023e245f896ceff1599cb9a.svg";
export { ForwardRef as ReactComponent };